(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/swish/components/deposit-info.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/swish/components/deposit-info.js');

'use strict';

const {
  ReactInfoButtonText
} = svs.tb_ui;
const {
  showMobileNumberInfo
} = svs.accountservicesReact.deposit.dialogs.swishDialogs;
const DepositInfo = () => {
  const handleMobileNumberInfo = e => {
    e.preventDefault();
    showMobileNumberInfo();
  };
  return React.createElement("div", {
    className: "margin-xs-top-1"
  }, React.createElement("div", null, React.createElement("div", null, "Bekr\xE4fta ins\xE4ttningen i din Swish-app. Ditt mobilnummer sparas i samband med ins\xE4ttning."), React.createElement("div", {
    className: "margin-xs-top-1 pointer"
  }, React.createElement(ReactInfoButtonText, {
    onClick: handleMobileNumberInfo,
    text: "Hur anv\xE4nder vi ditt mobilnummer?"
  }))));
};
svs.accountservicesReact.deposit.swish.components.DepositInfo = DepositInfo;

 })(window);